import { useTranslation } from "react-i18next";
import PageContentWrapper from "../../components/mui/app/pageContentWrapper/pageContentWrapper";
import { PAGE_HOME } from "../../locales/pages/namespaces";
import Applications from "../applications/applications";
import Login from "../login/login";

const Home = (props) => {
	const { t } = useTranslation(PAGE_HOME)
	return (
		<PageContentWrapper>
			<Applications/>
		</PageContentWrapper>
	);
};

export default Home